import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import ProductCard from './ProductCard';

export default function SimpleCollection(props: any) {
  return (
    <Grid
      container
      spacing={2}
      mb={2}
      ml={1}
      columns={{ xs: 3, sm: 3, md: 6, lg: 12 }}
      justifyContent='center'
      alignItems='center'
      width='100%'
    >
      {props.products.map((product: any) => (
        <Grid xs={3} sm={3} md={2} lg={4} key={product.handle}>
          <ProductCard {...product} />
        </Grid>
      ))}
    </Grid>
  );
}
